import { ChangeEventHandler, FC } from 'react';

import { formatPrice } from '~utils/hooks/usePrice';

import { PickedTicket, Ticket } from '~types';

import styles from './Tickets.module.css';

interface Props {
  ticketsPrices: Ticket[];
  data: Ticket;
  locked?: boolean;
  onRemove: (ticketId: string) => void;
  onChange: (ticket: PickedTicket) => void;
}

const TicketRow: FC<Props> = ({ data, locked = false, onChange, onRemove, ticketsPrices }) => {
  const handleChange: ChangeEventHandler<HTMLSelectElement> = (evt) => {
    const { target } = evt;

    const selected = ticketsPrices.find((t) => t.code === target.value);

    if (selected) {
      const pickedTicket = {
        ...selected,
        id: `${data.id}`,
      };

      // setTicket(selected);
      onChange(pickedTicket);
    }
  };

  return (
    <div className={styles.ticketRowSection}>
      <span className="w-10">{data.id}</span>
      <div className="flex-[3]">
        <select onChange={handleChange} className={styles.ticketRowWrapper} value={data.code}>
          {ticketsPrices?.map((ticket) => (
            <option key={ticket.code} value={ticket.code}>
              {ticket.description}
            </option>
          ))}
        </select>
      </div>
      <span className={styles.ticketPrice}>
        <span className="font-bold">{formatPrice(data.price)}</span>
        {!locked && (
          <span
            role="button"
            title="Quitar"
            className={styles.removeTicketButton}
            onClick={() => {
              onRemove(`${data.id}`);
            }}
          >
            &times;
          </span>
        )}
      </span>
    </div>
  );
};

export default TicketRow;
